import React, {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid
} from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import GrantInfo from './grant-info';
import {ShippingInstructionService} from '../../services';
import {ShippingInstructionContext} from "./shipping-instruction-context";
import ShippingInstructionSections from './si-sections';
import {NotificationContext} from "../../components/NotificationContext";
import Prompt from "../../customUtil/Prompt";
import {CurrentUserContext} from "../../components/CurrentUserContext";

const ShippingInstrutionForm = () => {
    const {data, setData, methods} = useContext(ShippingInstructionContext);
    const [isReady, setIsReady] = useState(false);
    const {showMessage, showError} = useContext(NotificationContext);
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const {rights} = useContext(CurrentUserContext);
    const [showProgress, setShowProgress] = useState(false);

    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
      const [isVisibleDialog, setVisibleDialog] = useState(false);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );
      
      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);


    useEffect(() => {
        if (id.includes('start-')) {
            const theId = id.split('-')[1];
            ShippingInstructionService.duplicate(theId)
                .then((response) => {
                    setData(response.data)
                    setIsReady(true);
                });
        } else if (id !== "new") {
            setTriggerExit({...triggerExit, onOk:false})
            ShippingInstructionService.getById(id).then((response) => {
                setData(response.data)
                setIsReady(true);
            });
        } else {
            setData({
                country: {},
                consignee: {},
                shipmentMode: {},
                partnerSite: {},
                documents: [],
                sectionStatements: [],
                commodityTypes: [],
                clientIncoTerms: [{incoTerm: {}}],
                vendorIncoTerms: [{incoTerm: {}}]
            });
            setIsReady(true);
        }
    }, [id, setData]);

    const {handleSubmit, errors} = methods;

    useEffect(() => {
        if (Object.keys(errors).length > 0) {
            showError('There are errors on this form. Please fix those and try again.')
        }
        // eslint-disable-next-line
    }, [errors]);

    const onSubmit = d => {
        setIsReady(false);
        setBlock(false);
        setVisibleDialog(false);
       
        const request = {
            ...data, ...d
        };
       
         
      
      
        if (data.id) {  

            const tempArray = [];
            let docApproval = [];
            let attachToShipment = [];
            if(request.documents.length > 0){
                for( let document of request.documents){
                    if(document.sectionId === 5){
                        docApproval.push(document);
                    }                 
                    if(document.sectionId === 7){
                        attachToShipment.push(document);
                    }                   
                    if(document.sectionId === 6){
                        tempArray.push(document);
                    }                    
                }                
            }
            if(request.otherDocuments.length > 0 ){
                for(let otherDocument of request.otherDocuments){
                    if(otherDocument.sectionId === 5){
                        docApproval.push(otherDocument);
                    }               
                    if(otherDocument.sectionId === 7){
                        attachToShipment.push(otherDocument);
                    }                   
                    if(otherDocument.sectionId === 6){
                        tempArray.push(otherDocument);
                    } 
                }
                   
            }
            if(request.sectionStatements.length > 0 ){
                for(let sectionStatement of request.sectionStatements){
                    if(sectionStatement.sectionId === 7){
                        attachToShipment.push(sectionStatement);
                    }
                    if(sectionStatement.sectionId === 6){
                        tempArray.push(sectionStatement)
                    } 
                }                  
            }
            if(tempArray.length > 0){
                request.hasCourierInstruction = true;
            }else{
                request.hasCourierInstruction = false;
            }

            if(attachToShipment.length > 0){
                request.hasAttachToShipment = true
            }else{
                 request.hasAttachToShipment = false
            }

           if(docApproval.length === 0){
            showError('Documents are required under Documnets Approval section');
                setIsReady(true);
               
            // }
            // else  if(attachToShipment.length === 0){
            //     showError('Documents are required under Attach to Shipment section.');
            //     setIsReady(true);
            }else
            ShippingInstructionService
                .update(request)
                .then((response) => {                
                    setData(response.data);
                    showMessage('Shipping Instruction updated.')
                    setIsReady(true);
                    setBlock(false);
                    setVisibleDialog(false);                    
                }).catch(error => {
                showMessage(error.message, 'error')
            });





        } else {
            if(request.otherDocuments){
           request.otherDocuments = request.otherDocuments.map(item => ({ ...item, id: null }));
            }
            ShippingInstructionService.create(request)
                .then((response) => {
                    if(response.data){
                        setData(response.data);
                        showMessage('Shipping Instruction Created.');
                        setIsReady(true);
                        setBlock(false);
                        setVisibleDialog(false);                       
                        history.push('/shipping-instruction/' + response.data.id);
                                              
                    }                  
                }).catch(error => {
                showMessage(error.message, 'error')
            });
        }
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });      
    };

    const handleClose = () => {
        setOpenConfirmation(false);
    }

    const removeShippingInstruction = () => {
        setShowProgress(true);
        ShippingInstructionService.delete(data.id).then((response) => {                
                showMessage('Successfully Deleted');
                history.push("/shipping-instructions");    
                showProgress(false);                                 
            }).catch((response) => {
            handleClose();
            showProgress(false);     
        });
    }

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }

      const checkInnerChildModified = (isDirty) => {
        if(isDirty){
            setBlock(true);
               }
            }
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }
    return (
        <React.Fragment>
            <header>
                <h1>Shipping Instructions</h1>
            </header>
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={(event) => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <GrantInfo {...methods} />
                    </Grid>
                    {
                        data.id !== undefined &&
                        <Grid item xs={9}>
                            <ShippingInstructionSections checkInnerChildModified={checkInnerChildModified}/>
                        </Grid>
                    }

                    <Grid item xs={12}>
                        &nbsp;
                    </Grid>
                    <Grid item xs={9}>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                        </Grid>
                        {(rights.includes("ROLE_SI_ADMIN") && id !== 'new') &&    
                     <Grid item xs={3}>
                     <Button variant="contained" color="danger" onClick={() => setOpenConfirmation(true)}>Remove shipping instruction</Button>
                    </Grid>
                        }
                       
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
            <Dialog open={openConfirmation} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>                      
                          Are you sure you want to delete this shipping instruction?                                           
                    </DialogContent>
                    <DialogActions>
                    {showProgress &&  <CircularProgress style={{width: "12px", height: "10px"}}/>} 
                    <Button onClick={removeShippingInstruction} color="primary" disabled={showProgress}>
                            yes
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
           </React.Fragment>
    );
};

export default ShippingInstrutionForm;
